import { useState, useRef } from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import RetailHomeImage from '../../assets/retail-home-image.png'
import TrustedPosImage1 from '../../assets/trusted-pos-image-1.png'
import TrustedPosImage2 from '../../assets/trusted-pos-image-2.png'
import TrustedPosImage3 from '../../assets/trusted-pos-image-3.png'
import TrustedPosImage4 from '../../assets/trusted-pos-image-4.png'
import TrustedPosImage5 from '../../assets/trusted-pos-image-5.png'
import TrustedPosImage6 from '../../assets/trusted-pos-image-6.png'
import NetImage from '../../assets/net-image.jpg'
// import PointTick from '../../assets/point-tick.png'
// import WhiteColorTick from '../../assets/white-color-tick.png'
// import WhatsappSmallIcon from '../../assets/whatsapp-small-icon.png'
import sendMessageImage from '../../assets/send-message-image.png'
import PowerfullFeatureImage1 from '../../assets/powerfull-feature-image-1.png'
import PowerfullFeatureImage2 from '../../assets/powerfull-feature-image-2.png'
import PowerfullFeatureImage3 from '../../assets/powerfull-feature-image-3.png'
import PowerfullFeatureImage4 from '../../assets/powerfull-feature-image-4.png'
import PowerfullFeatureImage5 from '../../assets/powerfull-feature-image-5.png'
import PowerfullFeatureImage6 from '../../assets/powerfull-feature-image-6.png'
import PowerfullFeatureImage7 from '../../assets/powerfull-feature-image-7.png'
import PowerfullFeatureIcon1 from '../../assets/powerfull-feature-icon-1.png'
import PowerfullFeatureIcon2 from '../../assets/powerfull-feature-icon-2.png'
import PowerfullFeatureIcon3 from '../../assets/powerfull-feature-icon-3.png'
import PowerfullFeatureIcon4 from '../../assets/powerfull-feature-icon-4.png'
import PowerfullFeatureIcon5 from '../../assets/powerfull-feature-icon-5.png'
import PowerfullFeatureIcon6 from '../../assets/powerfull-feature-icon-6.png'
import PowerfullFeatureIcon7 from '../../assets/powerfull-feature-icon-7.png'
import RightArrow from '../../assets/fleetorder-right-arrow.png'
import SuperMarketImage from '../../assets/supermarket-image.jpg'
import ClothingShopImage from '../../assets/clothing-image.jpg'
import MSMEImage from '../../assets/msme-image.jpg'
import ExportImportImage from '../../assets/export-import-image.jpg'
import WholesaleImage from '../../assets/wolesale-image.jpg'
import PharmacyImage from '../../assets/Pharmacy-image.jpg'
import MessageIcon from '../../assets/message-icon-home-1.png'
import LocationIcon from '../../assets/location-icon-contactus.png'
import { FaTshirt, FaPills, FaBook, FaStore, FaAppleAlt, FaTruck } from "react-icons/fa";
import './Retail.css'
import { TypeAnimation } from 'react-type-animation';


const establishments = [
    {
        name: "Supermarkets",
        title: "🏬 Supermarkets",
        points: [
            "Barcode & Bulk Billing",
            "Shelf & Stock Management",
            "Quick Self-Checkout Options",
        ],
        image: SuperMarketImage,
    },
    {
        name: "Clothing Stores",
        title: "👕 Clothing & Apparel",
        points: [
            "Size, Color & Variant Management",
            "Customer Purchase Insights",
            "Online + Offline Integration",
        ],
        image: ClothingShopImage,
    },
    {
        name: "MSMEs",
        title: "🏭 MSME Businesses",
        points: [
            "Affordable & Scalable POS",
            "Detailed Reports & Analytics",
            "Multi-Location Support",
        ],
        image: MSMEImage,
    },
    {
        name: "Export & Import",
        title: "🌍 Export & Import",
        points: [
            "Multi-Currency & Multi-Language",
            "Automated Compliance & Documentation",
            "Shipment & Logistics Tracking",
        ],
        image: ExportImportImage,
    },
    {
        name: "Wholesale",
        title: "📦 Wholesale",
        points: [
            "Bulk Order Processing",
            "Credit & Ledger Management",
            "GST & Tax-Compliant Billing",
        ],
        image: WholesaleImage,
    },
    {
        name: "Pharmacy",
        title: "💊 Pharmacy",
        points: [
            "Prescription Management",
            "Expiry & Batch Tracking",
            "Integrated e-Medicine Catalog",
        ],
        image: PharmacyImage,
    },
];

const industries = [
    { name: "MSMEs", icon: <FaStore /> },
    { name: "Pharmacy", icon: <FaPills /> },
    { name: "Grocery Stores", icon: <FaAppleAlt /> },
    { name: "Supermarkets", icon: <FaStore /> },
    { name: "Export & Import", icon: <FaTruck /> },
    { name: "Clothing Shops", icon: <FaTshirt /> },
    { name: "Book Shops", icon: <FaBook /> },
    { name: "Wholesale", icon: <FaStore /> },
];


function Retail() {
    const [selected, setSelected] = useState(establishments[0]);
    const [activeView, setActiveView] = useState('contact');
    const sectionRef = useRef(null);

    const scrollToSection = () => {
        sectionRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    const [formData, setFormData] = useState({
        name: "",
        product: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleWhatsAppSubmit = (e) => {
        e.preventDefault();

        const phoneNumber = "+917386616587";
        const { name, product } = formData;

        const whatsappMessage = `Hey, I am ${name}.\n\nI am interested in ${product} POS.\n\nLooking forward to a demo!`;

        const encodedMessage = encodeURIComponent(whatsappMessage);

        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;

        window.open(whatsappUrl, "_blank");
        setFormData({
            name: "",
            product: "",
        });
    };
    return (
        <>
            <Navbar />

            <div className="retial-main-container">
                <div className="retial-home-main-container">
                    <div>
                        {/* <h1 className="retail-main-heading">Smart <span className="retail-span">POS</span> for Retail Success</h1> */}
                         <TypeAnimation
                    sequence={[
                        // Same substring at the start will only be typed out once, initially
                        'Transform Your Retail Operations with Smart POS',
                        1000, // wait 1s before replacing "Mice" with "Hamsters"
                        'Transform Your Retail Operations with Smart POS - for Supermarkets',
                        2000,
                        'Transform Your Retail Operations with Smart POS - for Clothing Stores',
                        2000,
                        'Transform Your Retail Operations with Smart POS - for MSMEs',
                        2000,
                        'Transform Your Retail Operations with Smart POS - for Export & Import',
                        2000,
                        'Transform Your Retail Operations with Smart POS - for Wholesale',
                        2000,
                        'Transform Your Retail Operations with Smart POS - for Pharmacies',
                        2000
                    ]}
                    wrapper="span"
                    speed={50}
                    // style={{ fontSize: '42px', display: 'inline-block',color:"white",fontWeight:"bold",marginTop:"12px" }}
                    className="retail-main-heading"
                    repeat={Infinity}
                />
                        <p className="retail-description">Simplify billing, manage inventory, and grow your retail business with ease.</p>
                        <div className="retail-buttons-container">
                            <button className="retial-button" onClick={scrollToSection}>Get Started</button>
                            <button className="retial-button retial-demo-button" onClick={scrollToSection}>Book Demo</button>
                        </div>
                    </div>
                    <div className="retail-image-container">
                        <img src={RetailHomeImage} alt="Retail-Home-Image" className="retial-home-image" />
                    </div>
                </div>
            </div>


            <div className="retail-trusted-pos-main-container">
                <h1 className="retail-trusted-main-heading">Why Retailers <span className="retail-span">Trust</span> Our POS</h1>
                <p className="retail-description">Powerful features designed for retail success</p>

                <div className="retail-trusted-images-cards">

                    <div className="retial-trusted-card">
                        <div className="trusted-image-section">
                            <img src={TrustedPosImage1} alt="trusted-image-pos" className="trusted-image-pos" />
                        </div>
                        <h1 className="retail-trusted-pos-title">Quick & Easy Billing</h1>
                        <p className="retail-trusted-pos-description">Streamline your checkout process with our intuitive POS system for faster transactions.</p>
                        <div className="read-more-container">
                            <img src={RightArrow} alt="right-arrow" className="right-arrow" />
                            <p className="read-more-text">Read More</p>
                        </div>
                    </div>

                    <div className="retial-trusted-card">
                        <div className="trusted-image-section">
                            <img src={TrustedPosImage2} alt="trusted-image-pos" className="trusted-image-pos" />
                        </div>
                        <h1 className="retail-trusted-pos-title">Smart Inventory</h1>
                        <p className="retail-trusted-pos-description">Automated inventory tracking with real- time updates and low-stock alerts.</p>
                        <div className="read-more-container">
                            <img src={RightArrow} alt="right-arrow" className="right-arrow" />
                            <p className="read-more-text">Read More</p>
                        </div>
                    </div>

                    <div className="retial-trusted-card">
                        <div className="trusted-image-section">
                            <img src={TrustedPosImage4} alt="trusted-image-pos" className="trusted-image-pos" />
                        </div>
                        <h1 className="retail-trusted-pos-title">Retail-Specific Modules</h1>
                        <p className="retail-trusted-pos-description">Customizable modules designed for different retail sectors and business needs.</p>
                        <div className="read-more-container">
                            <img src={RightArrow} alt="right-arrow" className="right-arrow" />
                            <p className="read-more-text">Read More</p>
                        </div>
                    </div>

                    <div className="retial-trusted-card">
                        <div className="trusted-image-section">
                            <img src={TrustedPosImage3} alt="trusted-image-pos" className="trusted-image-pos" />
                        </div>
                        <h1 className="retail-trusted-pos-title">Franchise</h1>
                        <p className="retail-trusted-pos-description">Manage multiple locations from one central dashboard with unified reporting.</p>
                        <div className="read-more-container">
                            <img src={RightArrow} alt="right-arrow" className="right-arrow" />
                            <p className="read-more-text">Read More</p>
                        </div>
                    </div>

                    <div className="retial-trusted-card">
                        <div className="trusted-image-section">
                            <img src={TrustedPosImage6} alt="trusted-image-pos" className="trusted-image-pos" />
                        </div>
                        <h1 className="retail-trusted-pos-title">Reports & Analytics</h1>
                        <p className="retail-trusted-pos-description">Comprehensive business insights with detailed reports and performance analytics.</p>
                        <div className="read-more-container">
                            <img src={RightArrow} alt="right-arrow" className="right-arrow" />
                            <p className="read-more-text">Read More</p>
                        </div>
                    </div>

                    <div className="retial-trusted-card">
                        <div className="trusted-image-section">
                            <img src={TrustedPosImage5} alt="trusted-image-pos" className="trusted-image-pos" />
                        </div>
                        <h1 className="retail-trusted-pos-title">Mobile Ready</h1>
                        <p className="retail-trusted-pos-description">Access your POS system anywhere with our responsive mobile-friendly interface.</p>
                        <div className="read-more-container">
                            <img src={RightArrow} alt="right-arrow" className="right-arrow" />
                            <p className="read-more-text">Read More</p>
                        </div>
                    </div>

                </div>
            </div>

            <div className="powerfull-features-main-container">
                <img src={NetImage} alt="net-image" className="net-image" />
                <h1 className="powerfull-features-heading">Powerful Features, <span className="retail-span">Built for You</span></h1>
                <p className="powerfull-features-description">Everything you need, exactly how you need it.</p>

                <div className="powerfull-features-cards-section">

                    <div className="powerfill-feature-card">
                        <img src={PowerfullFeatureImage1} alt="powerfull-feature-image" className="powerfull-feature-image-retail" />
                        <div className="powerfull-feature-content-container">
                            <h1 className="powerfull-title-span">Barcode</h1>
                            <p className="powerfull-feature-description">Eliminate queues and manual errors. Our system provides quick product identification and checkout, making your sales process faster and more accurate than ever.</p>
                            <div className="powerfull-feature-fotter">
                                <img src={PowerfullFeatureIcon1} alt="powerfull-feature-fotter-icon" className="powerfull-feature-fotter-icon" />
                                <p className="powerfull-feature-fotter-text">Instant Recognition</p>
                            </div>
                        </div>
                    </div>

                    <div className="powerfill-feature-card">
                        <div className="powerfull-feature-content-container">
                            <h1 className="powerfull-feature-title">Build Relationships <span className="powerfull-title-span">That Last</span></h1>
                            <p className="powerfull-feature-description">Turn first-time buyers into lifelong fans. Create and manage custom rewards programs, track points, and offer personalized discounts to build a strong, loyal customer base.</p>
                            <div className="powerfull-feature-fotter">
                                <img src={PowerfullFeatureIcon2} alt="powerfull-feature-fotter-icon" className="powerfull-feature-fotter-icon" />
                                <p className="powerfull-feature-fotter-text">Customer Retention</p>
                            </div>
                        </div>
                        <img src={PowerfullFeatureImage2} alt="powerfull-feature-image" className="powerfull-feature-image-retail" />
                    </div>

                    <div className="powerfill-feature-card">
                        <img src={PowerfullFeatureImage3} alt="powerfull-feature-image" className="powerfull-feature-image-retail" />
                        <div className="powerfull-feature-content-container">
                            <h1 className="powerfull-feature-title">Always Compliant, <span className="powerfull-title-span">Always Ready</span></h1>
                            <p className="powerfull-feature-description">Stay ahead of regulations with zero effort. Our POS handles all GST and tax calculations automatically, ensuring your billing is always 100% compliant.</p>
                            <div className="powerfull-feature-fotter">
                                <img src={PowerfullFeatureIcon3} alt="powerfull-feature-fotter-icon" className="powerfull-feature-fotter-icon" />
                                <p className="powerfull-feature-fotter-text">100% Compliance</p>
                            </div>
                        </div>
                    </div>

                    <div className="powerfill-feature-card">
                        <div className="powerfull-feature-content-container">
                            <h1 className="powerfull-title-span">Supplier Management</h1>
                            <p className="powerfull-feature-description">Streamline purchase orders, track payments, and manage vendor relations efficiently from a single dashboard. Keep your supply chain organized and transparent.</p>
                            <div className="powerfull-feature-fotter">
                                <img src={PowerfullFeatureIcon4} alt="powerfull-feature-fotter-icon" className="powerfull-feature-fotter-icon" />
                                <p className="powerfull-feature-fotter-text">Streamlined Operations</p>
                            </div>
                        </div>
                        <img src={PowerfullFeatureImage4} alt="powerfull-feature-image" className="powerfull-feature-image-retail" />
                    </div>

                    <div className="powerfull-features-bottom-cards-section">

                        <div className="powerfill-feature-card-bottom">
                            <img src={PowerfullFeatureImage5} alt="powerfull-feature-image" className="powerfull-feature-image-retail" />
                            <div className="powerfull-feature-content-container">
                                <h1 className="powerfull-feature-title">Internet Down? <span className="powerfull-title-span">No Problem</span></h1>
                                <p className="powerfull-feature-description">Continue making sales without interruption. Your data will automatically sync the moment you're back online. Never let connectivity issues stop your business.</p>
                                <div className="powerfull-feature-fotter">
                                    <img src={PowerfullFeatureIcon5} alt="powerfull-feature-fotter-icon" className="powerfull-feature-fotter-icon" />
                                    <p className="powerfull-feature-fotter-text">Uninterrupted Service</p>
                                </div>
                            </div>
                        </div>

                        <div className="powerfill-feature-card-bottom">
                            <img src={PowerfullFeatureImage6} alt="powerfull-feature-image" className="powerfull-feature-image-retail" />
                            <div className="powerfull-feature-content-container">
                                <h1 className="powerfull-title-span">Your Data, Your Way</h1>
                                <p className="powerfull-feature-description">Seamlessly import or export your business data for accounting, analysis, or management. Your information is always accessible and ready when you need it.</p>
                                <div className="powerfull-feature-fotter">
                                    <img src={PowerfullFeatureIcon6} alt="powerfull-feature-fotter-icon" className="powerfull-feature-fotter-icon" />
                                    <p className="powerfull-feature-fotter-text">Complete Data Control</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="powerfill-feature-card">
                        <div className="powerfull-feature-content-container">
                            <h1 className="powerfull-feature-title">Your Business <span className="powerfull-title-span">In Your Pocket</span></h1>
                            <p className="powerfull-feature-description">Use your mobile device to manage sales, check inventory, and run your store from anywhere. Never miss an opportunity, even when you're away from the counter.</p>
                            <div className="powerfull-feature-fotter">
                                <img src={PowerfullFeatureIcon7} alt="powerfull-feature-fotter-icon" className="powerfull-feature-fotter-icon" />
                                <p className="powerfull-feature-fotter-text">Sell From Anywhere</p>
                            </div>
                        </div>
                        <img src={PowerfullFeatureImage7} alt="powerfull-feature-image" className="powerfull-feature-image-retail" />
                    </div>

                </div>
            </div>


            {/* <div className="many-retails-main-container">
                <div className="many-retails-content-container">
                    <h1 className="many-retails-title">One POS, Many Retail Industries</h1>
                    <p className="many-retails-description">From local stores to global trade, we've got you covered.</p>
                </div>
            </div> */}
            <div className="many-retails-main-container">
                <div className="many-retails-content-container">
                    <h1 className="many-retails-title">One POS, Many Retail Businesses</h1>
                    <p className="many-retails-description">
                        From local stores to global trade, we've got you covered.
                    </p>
                </div>

                <div className="many-retails-cards-container">
                    {/* Left Column - scroll up */}
                    <div className="scroll-column scroll-up curve-left">
                        {[...industries, ...industries].map((item, i) => (
                            <div className="industry-card" key={i}>
                                <div className="icon">{item.icon}</div>
                                <span className="product-name-many-retail">{item.name}</span>
                            </div>
                        ))}
                    </div>

                    {/* Right Column - scroll down */}
                    <div className="scroll-column scroll-down curve-right">
                        {[...industries, ...industries].map((item, i) => (
                            <div className="industry-card" key={i}>
                                <div className="icon">{item.icon}</div>
                                <span className="product-name-many-retail">{item.name}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>


            <div className="various-establlishment-main-container">
                <h1 className="various-establishment-heading">
                    Versatile Across Various Establishments
                </h1>

                <div className="various-establishment-buttons-container">
                    {establishments.map((est, index) => (
                        <button
                            key={index}
                            className={`various-establishment-button ${selected.name === est.name ? "active" : ""
                                }`}
                            onClick={() => setSelected(est)}
                        >
                            {est.name}
                        </button>
                    ))}
                </div>

                <div className="various-establishment-content-container">
                    <div className="various-establishment-content">
                        <h1 className="varous-establishment-title">{selected.title}</h1>
                        <ul>
                            {selected.points.map((point, index) => (
                                <li key={index} className="various-points">
                                    {point}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <img
                        src={selected.image}
                        alt={`${selected.name.toLowerCase()}-image`}
                        className="super-market-image"
                    />
                </div>
            </div>

            {/* <div className="choose-plan-main-container">
                <div className="choose-plan-heading-section">
                    <h1 className="choose-plan-heading">Choose Your Plan</h1>
                    <p className="choose-plan-description">Streamline your restaurant operations with our comprehensive management solutions</p>
                </div>
                <div className="choose-plans-cards-container">

                    <div className="choose-plan-card">
                        <h1 className="plan-title">Standard Plan</h1>
                        <p className="plan-description">Perfect for growing restaurants</p>
                        <h1 className="plan-cost">₹6,500</h1>
                        <div className="plan-points-container">
                            <div className="points-plan">
                                <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                <p className="point-text">Front Desk Management</p>
                            </div>
                            <div className="points-plan">
                                <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                <p className="point-text">Restaurant & Bar Billing</p>
                            </div>
                            <div className="points-plan">
                                <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                <p className="point-text">Franchise</p>
                            </div>
                            <div className="points-plan">
                                <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                <p className="point-text">Inventory Management</p>
                            </div>
                            <div className="points-plan">
                                <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                <p className="point-text">Reports & Analytics</p>
                            </div>
                            <div className="points-plan">
                                <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                <p className="point-text">24/7 Support</p>
                            </div>
                            <div className="points-plan">
                                <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                <p className="point-text">Merchant Apps</p>
                            </div>
                        </div>
                        <div className="plan-addons-container">
                            <h1 className="plan-addon-heading">Available Add-ons</h1>
                            <div className="whatsapp-plan-container">
                                <div className="whatsapp-heading">
                                    <img src={WhatsappSmallIcon} alt="whatsapp-icon" className="whatsapp-small-icon" />
                                    <p className="whatsapp-title">whatsapp <span className="plans-all-text">Available with both plans</span></p>
                                </div>
                                <p className="plans-fotter-message">₹ 0.15 paisa/per message  (Excluding GST)</p>
                            </div>
                            <div className="plan-button-container">
                                <button className="plan-buttons">Get Started</button>
                            </div>
                        </div>


                    </div>

                    <div className="choose-plan-card Premium-Plan">
                        <div className="most-popular-button-container">
                            <button className="most-popular">Most Popular</button>
                        </div>
                        <h1 className="plan-title">Premium Plan</h1>
                        <p className="plan-description premium-description">Complete restaurant solution</p>
                        <h1 className="plan-cost">₹7,500</h1>
                        <div className="plan-points-container">
                            <div className="points-plan">
                                <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                <p className="point-text">Smart Upselling Engine</p>
                            </div>
                            <div className="points-plan">
                                <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                <p className="point-text">Advanced Room Booking Module</p>
                            </div>
                            <div className="points-plan">
                                <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                <p className="point-text">Restaurant & Bar Billing</p>
                            </div>
                            <div className="points-plan">
                                <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                <p className="point-text">Reports & Analytics</p>
                            </div>
                            <div className="points-plan">
                                <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                <p className="point-text">Reports & Analytics</p>
                            </div>
                            <div className="points-plan">
                                <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                <p className="point-text">Inventory Management</p>
                            </div>
                            <div className="points-plan">
                                <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                <p className="point-text">24/7 Support</p>
                            </div>
                            <div className="points-plan">
                                <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                <p className="point-text">Merchant Apps</p>
                            </div>
                            <div className="points-plan">
                                <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                <p className="point-text">Custom branding option</p>
                            </div>
                        </div>
                        <div className="plan-addons-container">
                            <h1 className="plan-addon-heading">Available Add-ons</h1>
                            <div className="whatsapp-plan-container Premium-Plan-whatsapp">
                                <div className="whatsapp-heading">
                                    <img src={WhatsappSmallIcon} alt="whatsapp-icon" className="whatsapp-small-icon" />
                                    <p className="whatsapp-title">whatsapp <span className="plans-all-text">Available with both plans</span></p>
                                </div>
                                <p className="plans-fotter-message">₹ 0.15 paisa/per message  (Excluding GST)</p>
                            </div>
                            <div className="plan-button-container">
                                <button className="plan-buttons premium-button">Get Started</button>
                            </div>
                        </div>


                    </div>

                </div>
            </div> */}


            <div className="contact-form-main-container-about" ref={sectionRef}>
                <div className="contact-form-content-container">
                    <div className="contactus-buttons-container">
                        <button
                            className={`contactus-form-buttons ${activeView === 'contact' ? 'active' : ''}`}
                            onClick={() => setActiveView('contact')}
                        >
                            <img src={MessageIcon} alt="message-icon" className="contact-form-icons" />
                            Contact Form
                        </button>

                        <button
                            className={`contactus-form-buttons ${activeView === 'location' ? 'active' : ''}`}
                            onClick={() => setActiveView('location')}
                        >
                            <img src={LocationIcon} alt="location-icon" className="contact-form-icons" />
                            Location
                        </button>
                    </div>



                    {activeView === 'contact' ? (
                        <>
                            <img src={sendMessageImage} alt="send-message-icon" className="send-message-icon" />
                            <h1 className="send-message-heading">Book a Demo</h1>
                            <p className="send-message-description">
                                Fill out the form below and connect us instantly.
                            </p>

                            <form className="send-message-form-main" onSubmit={handleWhatsAppSubmit}>
                                <div className="send-message-form">
                                    <div className="input-container">
                                        <label>Full Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            placeholder="John Doe"
                                            className="input-field"
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    {/* <div className="input-container">
                                        <label>Email Address</label>
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="john@example.com"
                                            className="input-field"
                                            onChange={handleChange}
                                            required
                                        />
                                    </div> */}
                                </div>

                                <div className="input-container">
                                    <label>Product</label>
                                    <select
                                        name="product"
                                        className="input-field"
                                        onChange={handleChange}
                                        required
                                    >
                                        {/* <option value="">Select a product</option>
                                        <option value="Fleet Eats">Fleet Eats</option> */}
                                        <option value="Fleet Mart">Fleet Mart</option>
                                        {/* <option value="Fleet Stay">Fleet Stay</option>
                                        <option value="Fleet Office">Fleet Office</option> */}
                                    </select>
                                </div>

                                {/* <div className="input-container">
                                    <label>Message</label>
                                    <textarea
                                        name="message"
                                        placeholder="Type your message here..."
                                        className="input-field"
                                        rows="6"
                                        onChange={handleChange}
                                        required
                                    ></textarea>
                                </div> */}

                                <button type="submit" className="send-message-button">
                                    Connect Us
                                </button>
                            </form>
                        </>
                    ) : (
                        // Location View
                        <div className="map-image-background">
                            <div className="reach-out-cards-container">
                               <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.5253765500493!2d78.37664357522262!3d17.434550583460727!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93e37831f177%3A0x32d4499d34baaa78!2sT-Hub%20Phase%202!5e0!3m2!1sen!2sin!4v1781782551831!5m2!1sen!2sin" 
                                width="600" 
                                height="450" 
                                style={{ border: 0 }} 
                                allowfullscreen 
                                loading="lazy" 
                                referrerpolicy="no-referrer-when-downgrade"
                                title="Thub Phase 2 Map"
                                ></iframe>
                            </div>
                        </div>

                    )}

                </div>
            </div>
            <Footer />
        </>
    )
}

export default Retail